<template>
  <div class="service">
    <Header />
    <div class="main">
      <!-- navbar -->
      <div class="navbar">
        <div v-for="(item, index) in tabbar" :key="item.id">
          <div
            class="navbar-item"
            :class="activeIndex == index ? 'navbar-active' : ''"
            @click="handleNav(index)"
          >
            {{ $t(item.title) }}
          </div>
        </div>
      </div>
      <!-- 动态组件 -->
      <keep-alive :include="['Organizing', 'Department', 'Sportteam']">
        <component :is="currentTabComponent"></component>
      </keep-alive>
    </div>
    <HomeFooter />
  </div>
</template>

<script>
import Header from '../../layout/Header.vue'
import HomeFooter from '../../layout/HomeFooter.vue'
import Organizing from './components/Organizing.vue'
import Department from './components/Department.vue'
import Sportteam from './components/Sportteam.vue'
export default {
  components: {
    Header,
    HomeFooter,
    Organizing,
    Department,
    Sportteam
  },
  data () {
    return {
      activeIndex: 0, // 激活组件
      tabbar: [
        {
          id: 1,
          title: '组委会',
          name: 'Organizing'
        },
        {
          id: 2,
          title: '主管部门',
          name: 'Department'
        },
        {
          id: 3,
          title: '运动队&运动员',
          name: 'Sportteam'
        }
      ]
    }
  },
  computed: {
    currentTabComponent () {
      return this.tabbar[this.activeIndex].name
    }
  },
  mounted (){
    this.activeIndex=this.$route.params.index||0
  },
  methods: {
    handleNav (index) {
      if(index!=0){
        this.$message.warning('内容暂未更新')
        return
      }
      this.activeIndex = index
    }
  }
}
</script>

<style lang="scss" scoped>
.service {
  width: 100%;
  .main {
    width: 100%;
    .navbar {
      width: 1200px;
      height: 70px;
      margin: 0 auto;
      display: flex;
      flex-direction: row;
      justify-content: flex-start;
      align-items: flex-end;
      box-sizing: border-box;
      .navbar-item {
        width: 154px;
        height: 54px;
        line-height: 54px;
        text-align: center;
        cursor: pointer;
        box-sizing: border-box;
        margin-right: 10px;
      }
      .navbar-active {
        background: #e5e5e5;
        border-radius: 10px 10px 0px 0px;
      }
      .tabbar-active:hover {
        border: 1px solid #e5e5e5;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/daoba-match/views/home/detail/Home.vue